import { render, staticRenderFns } from "./AllSeller.vue?vue&type=template&id=2af7e63a&"
import script from "./AllSeller.vue?vue&type=script&lang=js&"
export * from "./AllSeller.vue?vue&type=script&lang=js&"
import style0 from "./AllSeller.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports